(() => {
  const api = window.InstinctLevainSections = window.InstinctLevainSections || {};
  const tasks = new WeakSet();
  const resources = new Map();
  function once(key, load) {
    if (!resources.has(key)) {
      // Share each resource, retry one transient failure, and allow later recovery.
      resources.set(key, load().catch(() => load()).catch(error => {
        resources.delete(key);
        throw error;
      }));
    }
    return resources.get(key);
  }
  function script(url, key) {
    const previous = window[key];
    return new Promise((resolve, reject) => {
      const tag = document.createElement('script');
      tag.src = url;
      tag.async = true;
      tag.onload = () => {
        const constructor = window[key];
        window[key] = previous;
        resolve(constructor);
      };
      tag.onerror = () => { tag.remove(); reject(new Error('Unable to load ' + key)); };
      document.head.appendChild(tag);
    });
  }
  function css(url) {
    return new Promise((resolve, reject) => {
      const tag = document.createElement('link');
      tag.rel = 'stylesheet';
      tag.href = url;
      tag.onload = resolve;
      tag.onerror = () => { tag.remove(); reject(new Error('Unable to load slider styles')); };
      document.head.appendChild(tag);
    });
  }
  function prepare(withLazy) {
    const jobs = [
      once('swiper-css', () => css('https://cdn.jsdelivr.net/npm/swiper@11.2.10/swiper-bundle.min.css')),
      once('swiper-js', () => script('https://cdn.jsdelivr.net/npm/swiper@11.2.10/swiper-bundle.min.js', 'Swiper'))
        .then(constructor => { api.Swiper = constructor; })
    ];
    if (withLazy) {
      jobs.push(once('lazyload-js', () => script('https://cdn.jsdelivr.net/npm/vanilla-lazyload@19.1.3/dist/lazyload.min.js', 'LazyLoad'))
        .then(constructor => { api.LazyLoad = constructor; }));
    }
    return Promise.all(jobs);
  }
  api.observe = (selector, callback, withLazy = false) => {
    const root = document.querySelector(selector);
    if (!root || tasks.has(root)) return;
    tasks.add(root);
    const run = () => prepare(withLazy).then(() => {
      if (root.isConnected) callback();
    }).catch(error => { tasks.delete(root); console.error(error); });
    if (window.Shopify?.designMode || !('IntersectionObserver' in window)) {
      run();
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        observer.disconnect();
        run();
      }
    }, { rootMargin: '300px' });
    observer.observe(root);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    }, { once: true });
  };
})();
